import { AccountRole } from './account';

export enum LeadStatus {
  New = 'New',
  ScheduledCall = 'Scheduled call',
  CancelledCall = 'Cancelled call',
  Accepted = 'Accepted',
  Postponed = 'Postponed',
  Rejected = 'Rejected',
}

export type Lead = {
  id: string;
  fullName: string;
  phoneNumber: string;
  email: string;
  utcOffset: string;
  country: string;
  region: string;
  city: string;
  origin: string;
  role: AccountRole;
  status: LeadStatus;
  comment: string;
  rawData: Record<string, unknown>;
  timezone: string;
};
